import React from 'react';

function HeadingSection() {
  return (
    <header className="pt-20 pb-16 w-full bg-gray-50 max-sm:pt-16 max-sm:pb-10">
      <div className="px-5 text-center">
        <h1 className="mb-6 text-5xl font-bold leading-tight text-teal-600 max-sm:text-4xl">
          Get in Touch
        </h1>
        <p className="mx-auto text-lg leading-relaxed text-gray-500 max-w-[600px] max-sm:text-base">
          Have questions? We'd love to hear from you. Send us a message and
          we'll respond as soon as possible.
        </p>
      </div>
    </header>
  );
}

export default HeadingSection;
